var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRetail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4999 1.125C16.7748 1.125 16.1695 1.64025 16.0307 2.32425L15.1277 2.62501H2.88926C2.29452 2.62501 1.74626 2.89427 1.387 3.36301C1.02999 3.82876 0.91225 4.42276 1.0675 4.99949L2.5255 10.2232C2.74751 11.046 3.49749 11.6205 4.34799 11.6205L13.7493 11.625C14.3695 11.625 14.8749 12.1297 14.8749 12.75C14.8749 13.3703 14.3702 13.875 13.7499 13.875H13.612C13.3015 13.0042 12.4765 12.375 11.5 12.375C10.5235 12.375 9.6985 13.0042 9.388 13.875H6.86198C6.55148 13.0042 5.7265 12.375 4.75001 12.375C3.77351 12.375 2.94849 13.0042 2.638 13.875H1.74999C1.33525 13.875 1 14.211 1 14.625C1 15.039 1.33525 15.3749 1.74999 15.3749H2.638C2.94849 16.2458 3.77351 16.875 4.75001 16.875C5.7265 16.875 6.55152 16.2457 6.86202 15.3749H9.388C9.6985 16.2458 10.5235 16.875 11.5 16.875C12.4765 16.875 13.3015 16.2457 13.612 15.3749H13.75C15.1975 15.3749 16.375 14.1975 16.375 12.7499C16.375 11.6137 15.6445 10.6529 14.632 10.2884L15.9003 3.94874L16.5115 3.74551C16.7762 3.97876 17.1197 4.12502 17.5 4.12502C18.328 4.12502 19 3.45378 19 2.62501C19 1.79627 18.3279 1.125 17.4999 1.125Z",
    stroke: "#118F84",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRetail);
export default __webpack_public_path__ + "static/media/RETAIL.73eddf0da8a4cc5e3c1d9eb01b0b78e0.svg";
export { ForwardRef as ReactComponent };